import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { MynewsHeader } from "scmp-app/components/my-news/mynews-header";

export const StyledMynewsHeader = styled(MynewsHeader)`
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
  }
`;
